<template>
  <div class="about__wrap">
    <div v-if="step === 1" class="about__container">
      <h2 class="about__title">{{ getTranslatedText("About games") }}</h2>
      <ul class="about__list">
        <li class="about__list--item">
          <a @click="handleDetailPage(2)">{{ getTranslatedText("Guinne nap") }}</a>
        </li>
        <li class="about__list--item">
          <a @click="handleDetailPage(3)">{{ getTranslatedText("Guinne chance") }}</a>
        </li>
        <li class="about__list--item">
          <a @click="handleDetailPage(4)">{{ getTranslatedText("Guinne turbo") }}</a>
        </li>
        <li
            v-if="this.$store.state.isShow645"
            class="about__list--item"
        >
          <a @click="handleDetailPage(5)">{{ getTranslatedText("Loto 6/45") }}</a>
        </li>
      </ul>
    </div>
    <div v-if="step === 2" class="about_item">
      <div class="about_item__head">
        {{ getTranslatedText("1 - Loto Nap") }}
      </div>
      <div class="about_item__content" v-for="(lotoNap, index) in transformedData(this.dataLotonap)" :key="index">
        <div class="about_item__content__title">
          {{ getTranslatedText(lotoNap.title) }}
        </div>
        <div class="about_item__content__table">
          <div class="about_item__content__table__item">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">
                  {{ getTranslatedText("nombre de numéros gagnants") }}
                </th>
                <th scope="col">{{ getTranslatedText("Mise") }}</th>
                <th scope="col">{{ getTranslatedText("Gains en GNF") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ getTranslatedText(lotoNap.nombre_gains[0].text) }}</td>
                <td class="text-transform" :rowspan="lotoNap.nombre_gains.length">
                  {{ renderPrice(lotoNap.price) }} {{ getTranslatedText($store.state.userInfo.gamev3.currency_code) }}
                </td>
                <td>
                  {{ renderPrice(lotoNap.nombre_gains[0].price) }}
                </td>
              </tr>
              <template v-for="(nombre_gains, index) in lotoNap.nombre_gains">
                <tr v-if="index" :key="index">
                  <td>{{ getTranslatedText(nombre_gains.text) }}</td>
                  <td>{{ renderPrice(nombre_gains.price) }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 3" class="about_item">
      <div class="about_item__head">
        {{ getTranslatedText("2 - Loto Chance") }}
      </div>
      <div class="about_item__content" v-for="(lotoChance, index) in transformedData(this.dataChance)" :key="index">
        <div class="about_item__content__title">
          {{ getTranslatedText(lotoChance.title) }}
        </div>
        <div class="about_item__content__table">
          <div class="about_item__content__table__item">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">
                  {{ getTranslatedText("nombre de numéros gagnants") }}
                </th>
                <th scope="col">{{ getTranslatedText("Mise") }}</th>
                <th scope="col">{{ getTranslatedText("Gains en GNF") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ getTranslatedText(lotoChance.nombre_gains[0].text) }}</td>
                <td class="text-transform" :rowspan="lotoChance.nombre_gains.length">
                  {{ renderPrice(lotoChance.price) }} {{ getTranslatedText($store.state.userInfo.gamev3.currency_code) }}
                </td>
                <td>
                  {{ renderPrice(lotoChance.nombre_gains[0].price) }}
                </td>
              </tr>
              <template v-for="(nombre_gains, index) in lotoChance.nombre_gains">
                <tr v-if="index" :key="index">
                  <td>{{ getTranslatedText(nombre_gains.text) }}</td>
                  <td>{{ renderPrice(nombre_gains.price) }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 4" class="about_item">
      <div class="about_item__head">
        {{ getTranslatedText("3 - Loto Turbo") }}
      </div>
      <div class="about_item__content" v-for="(lotoTurbo, index) in transformedData(this.dataTurbo)" :key="index">
        <div class="about_item__content__title">
          {{ getTranslatedText(lotoTurbo.title) }}
        </div>
        <div class="about_item__content__table">
          <div class="about_item__content__table__item">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">
                  {{ getTranslatedText("nombre de numéros gagnants") }}
                </th>
                <th scope="col">{{ getTranslatedText("Mise") }}</th>
                <th scope="col">{{ getTranslatedText("Gains en GNF") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ getTranslatedText(lotoTurbo.nombre_gains[0].text) }}</td>
                <td class="text-transform" :rowspan="lotoTurbo.nombre_gains.length">
                  {{ renderPrice(lotoTurbo.price) }} {{ getTranslatedText($store.state.userInfo.gamev3.currency_code) }}
                </td>
                <td>
                  {{ renderPrice(lotoTurbo.nombre_gains[0].price) }}
                </td>
              </tr>
              <template v-for="(nombre_gains, index) in lotoTurbo.nombre_gains">
                <tr v-if="index" :key="index">
                  <td>{{ getTranslatedText(nombre_gains.text) }}</td>
                  <td>{{ renderPrice(nombre_gains.price) }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 5" class="about_item">
      <div class="about_item__head">
        {{ getTranslatedText("Loto 6/45") }}
      </div>
      <div class="about_item__content">
        <div class="about_item__content__table">
          <div class="about_item__content__table__item">
            <div class="about_item__content__table__item__title"> 
              {{ getTranslatedText('Répartition des Gains') }}
            </div>
            <table class="table table-winnings-645">
              <thead>
              <tr>
                <th scope="col" >
                  {{ getTranslatedText("Numéros corrects") }}
                </th>
                <th scope="col">{{ getTranslatedText("winning") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in loto645" :key="index">
                <td>{{ item.numbersN }}</td>
                <td>{{ item.winning }}</td>
              </tr>
              </tbody>
            </table>
            <i class="about_item__content__table__item__note"> 
              {{ getTranslatedText('*à partager entre le nombre de gagnants') }}
            </i>
          </div>
        </div>
      </div>
      <div class="about_item__content">
        <div class="about_item__content__table">
          <div class="about_item__content__table__item">
            <div class="about_item__content__table__item__title"> 
              {{ getTranslatedText('Nombre de combinaisons par type de Pari') }}
            </div>
            <table class="table table-combinations-645">
              <thead>
              <tr>
                <th scope="col">
                  {{ getTranslatedText("Type de Pari") }}
                </th>
                <th scope="col">{{ getTranslatedText("Nbre numéros") }}</th>
                <th scope="col">{{ getTranslatedText("Nbre combinaisons") }}</th>
                <th scope="col">{{ getTranslatedText("Prix ticket") }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in loto645Combinations" :key="index">
                <td>{{ item.type }}</td>
                <td>{{ item.numberN }}</td>
                <td>{{ item.combinations }}</td>
                <td>{{ renderPrice(item.price) }} {{ getTranslatedText($store.state.userInfo.gamev3.currency_code) }}</td>
              </tr>
              </tbody>
            </table>
            <div class="about_item__content__table__item__notes"> 
              <span class="about_item__content__table__item__notes-text">{{ getTranslatedText('Pari Simple') }}</span>
              <span class="about_item__content__table__item__notes-text">{{ getTranslatedText('Multiple7') }}</span>
              <span class="about_item__content__table__item__notes-text">{{ getTranslatedText('Multiple8') }}</span>
              <span class="about_item__content__table__item__notes-text">{{ getTranslatedText('Multiple9') }}</span>
              <span class="about_item__content__table__item__notes-text">{{ getTranslatedText('Multiple10') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import { formatPrice } from '@/utils/utils';

export default {
  mixins: [languageMixins],
  data() {
    return {
      step: 1,
      dataLotonap: [
        {
          title: "Nap 2: 2 numéros gagnants",
          nombre: [
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
            {
              text: "1 numéro",
            },
            {
              text: "0 numéro + 1 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "200000",
            },
            {
              price: "30000",
            },
            {
              price: "30000",
            },
            {
              price: "6000",
            },
            {
              price: "2000",
            },
          ],
        },
        {
          title: "Nap 3: 3 numéros gagnants",
          nombre: [
            {
              text: "3 numéros",
            },
            {
              text: "2 numéros + 1 bonus",
            },
            {
              text: "1 numéro + 2 bonus",
            },
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
            {
              text: "1 numéro",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "4000000",
            },
            {
              price: "200000",
            },
            {
              price: "120000",
            },
            {
              price: "80000",
            },
            {
              price: "4000",
            },
            {
              price: "4000",
            },
            {
              price: "2000",
            },
          ],
        },
        {
          title: "Nap 4: 4 numéros gagnants",
          nombre: [
            {
              text: "4 numéros",
            },
            {
              text: "3 numéros + 1 bonus",
            },
            {
              text: "2 numéros + 2 bonus",
            },
            {
              text: "3 numéros",
            },
            {
              text: "2 numéros + 1 bonus",
            },
            {
              text: "1 numéro + 2 bonus",
            },
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "20000000",
            },
            {
              price: "2000000",
            },
            {
              price: "2000000",
            },
            {
              price: "400000",
            },
            {
              price: "200000",
            },
            {
              price: "100000",
            },
            {
              price: "40000",
            },
            {
              price: "2000",
            },
          ],
        },
        {
          title: "Nap 5: 5 numéros gagnants",
          nombre: [
            {
              text: "5 numéros",
            },
            {
              text: "4 numéros + 1 bonus",
            },
            {
              text: "3 numéros + 2 bonus",
            },
            {
              text: "4 numéros",
            },
            {
              text: "3 numéros + 1 bonus",
            },
            {
              text: "2 numéros + 2 bonus",
            },
            {
              text: "3 numéros",
            },
            {
              text: "2 numéros + 1 bonus",
            },
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "200000000",
            },
            {
              price: "20000000",
            },
            {
              price: "20000000",
            },
            {
              price: "10000000",
            },
            {
              price: "1000000",
            },
            {
              price: "1000000",
            },
            {
              price: "200000",
            },
            {
              price: "30000",
            },
            {
              price: "24000",
            },
            {
              price: "2000",
            },
          ],
        },
      ],
      dataChance: [
        {
          title: "Chance 3: 3 numéros gagnants",
          nombre: [
            {
              text: "3 numéros",
            },
            {
              text: "2 numéros + 1 bonus",
            },
            {
              text: "1 numéro + 2 bonus",
            },
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "8000000",
            },
            {
              price: "160000",
            },
            {
              price: "160000",
            },
            {
              price: "80000",
            },
            {
              price: "4000",
            },
            {
              price: "4000",
            },
          ],
        },
        {
          title: "Chance 4: 4 numéros gagnants",
          nombre: [
            {
              text: "4 numéros",
            },
            {
              text: "3 numéros + 1 bonus",
            },
            {
              text: "2 numéros + 2 bonus",
            },
            {
              text: "3 numéros",
            },
            {
              text: "2 numéros + 1 bonus",
            },
            {
              text: "1 numéro + 2 bonus",
            },
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "20000000",
            },
            {
              price: "4000000",
            },
            {
              price: "4000000",
            },
            {
              price: "700000",
            },
            {
              price: "70000",
            },
            {
              price: "70000",
            },
            {
              price: "60000",
            },
            {
              price: "6000",
            },
            {
              price: "6000",
            },
          ],
        },
        {
          title: "Chance 5: 5 numéros gagnants",
          nombre: [
            {
              text: "5 numéros",
            },
            {
              text: "4 numéros + 1 bonus",
            },
            {
              text: "3 numéros + 2 bonus",
            },
            {
              text: "4 numéros",
            },
            {
              text: "3 numéros + 1 bonus",
            },
            {
              text: "2 numéros + 2 bonus",
            },
            {
              text: "3 numéros",
            },
            {
              text: "2 numéros + 1 bonus",
            },
            {
              text: "1 numéro + 2 bonus",
            },
            {
              text: "2 numéros",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "400000000",
            },
            {
              price: "40000000",
            },
            {
              price: "40000000",
            },
            {
              price: "10000000",
            },
            {
              price: "1000000",
            },
            {
              price: "1000000",
            },
            {
              price: "400000",
            },
            {
              price: "40000",
            },
            {
              price: "40000",
            },
            {
              price: "30000",
            },
          ],
        },
      ],
      dataTurbo: [
        {
          title: "Turbo 2: 2 numéros gagnants",
          nombre: [
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "4800000",
            },
            {
              price: "80000",
            },
            {
              price: "80000",
            },
          ],
        },
        {
          title: "Turbo 3: 3 numéros gagnants",
          nombre: [
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "1600000",
            },
            {
              price: "60000",
            },
            {
              price: "60000",
            },
          ],
        },
        {
          title: "Turbo 4: 4 numéros gagnants",
          nombre: [
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "800000",
            },
            {
              price: "50000",
            },
            {
              price: "50000",
            },
          ],
        },
        {
          title: "Turbo 5: 5 numéros gagnants",
          nombre: [
            {
              text: "2 numéros",
            },
            {
              text: "1 numéro + 1 bonus",
            },
            {
              text: "0 numéro + 2 bonus",
            },
          ],
          price: `2000 `,
          gains: [
            {
              price: "500000",
            },
            {
              price: "24000",
            },
            {
              price: "24000",
            },
          ],
        },
      ],
      loto645: [
        {
          numbersN: 6,
          winning: "Min. 1,000,000,000 GNF*",
        },
        {
          numbersN: 5,
          winning: "4,23% des mises participantes*",
        },
        {
          numbersN: 4,
          winning: "5,64% des mises participantes*",
        },
        {
          numbersN: 3,
          winning: "15,000 GNF par gagnant",
        }
      ],
      loto645Combinations: [
        {
          type: "Simple",
          numberN: "6",
          combinations: "1",
          price: "5000"
        },
        {
          type: "Multiple7",
          numberN: "7",
          combinations: "7",
          price: "35000"
        },
        {
          type: "Multiple8",
          numberN: "8",
          combinations: "28",
          price: "140000"
        },
        {
          type: "Multiple9",
          numberN: "9",
          combinations: "84",
          price: "420000"
        },
        {
          type: "Multiple10",
          numberN: "10",
          combinations: "210",
          price: "1050000"
        }
      ]
    };
  },
  methods: {
    transformedData(data) {
      return data?.map((item) => {
        const nombre_gains = item.nombre.map((nombre, index) => {
          return {
            text: nombre.text,
            price: item.gains[index].price,
          };
        });
        return {
          title: item.title,
          price: item.price,
          nombre_gains: nombre_gains,

        };
      });
    },
    handleDetailPage(number) {
      this.step = number;
    },
    renderPrice(price) {
      return formatPrice(price)
    },
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/about/_index.scss";
</style>

